<div id="FormatPassword_Tooltip" class="hidden">
  Must contain 8 to 50 characters including an uppercase letter, a lowercase letter, and a number or a special character
</div>